// ----------------------------------------------------------------------------
// Snippet: Currency/Country Switcher
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_currency-switcher.scss';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const CONTAINER_SELECTOR = '#currency-switcher';
const BUTTON_SELECTOR    = '.currency-switcher__toggle';
const INPUT_SELECTOR     = 'input[name="country_code"]';

// Classes
const OPEN_CLASS = 'js--is-open';


// -------------------------------------
// Helpers
// -------------------------------------

const initSWitcher = (container) => {
    const button = container.querySelector(BUTTON_SELECTOR);
    const links = container.querySelectorAll('a');

    container.button = button;
    button.container = container;

    container.addEventListener('keyup', handleKeyup);
    container.addEventListener('focusout', handleFocusOut);

    button.addEventListener('click', handleButtonClick);

    links.forEach((link) => {
        link.container = container;
        link.addEventListener('click', handleItemClick);
    });
}

const handleKeyup = (event) => {
    if (event.key !== 'Escape') return;
    closeSelector(event.currentTarget);
}

const handleFocusOut = (event) => {
    const isChild = event.currentTarget.contains(event.relatedTarget);

    if (!event.relatedTarget || !isChild) {
        closeSelector(event.currentTarget)
    }
}

const handleButtonClick = (event) => {
    const $this = event.currentTarget;

    if ($this.getAttribute('aria-expanded') === 'true') {
        closeSelector($this.container);
    } else {
        openSelector($this.container);
    }
}

const handleItemClick = (event) => {
    event.preventDefault();

    const $this = event.currentTarget;
    const form = $this.closest('form');
    const input = $this.container.querySelector(INPUT_SELECTOR);

    if (input.value === $this.dataset.value) {
        closeSelector($this.container);
    } else {
        input.value = $this.dataset.value;
        if (form) form.submit();
    }
}

const closeSelector = (container) => {
    container.classList.remove(OPEN_CLASS);
    container.button.setAttribute('aria-expanded', 'false');
}

const openSelector = (container) => {
    container.classList.add(OPEN_CLASS);
    container.button.setAttribute('aria-expanded', 'true');
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);

    containers.forEach((container) => {
        initSWitcher(container);
    });
});

